import React, { useState, useEffect } from 'react';

const renderStars = (rating) => {
  const stars = [];
  for (let i = 0; i < 5; i++) {
    if (i < rating) {
      stars.push(<span key={i} className="star filled">&#9733;</span>); // Filled star
    } else {
      stars.push(<span key={i} className="star empty">&#9734;</span>); // Empty star
    }
  }
  return stars;
};

const TestimonialCard = ({ testimonial, onReviewChange, initialReviewIndex }) => {
  const [animationClass, setAnimationClass] = useState('fade-in-up');
  const [displayedTestimonial, setDisplayedTestimonial] = useState(testimonial);

  useEffect(() => {
    // When the testimonial prop changes (from parent), trigger animation
    if (testimonial.review !== displayedTestimonial.review) { // Compare by review content for uniqueness
      setAnimationClass('fade-out-down');
      setTimeout(() => {
        setDisplayedTestimonial(testimonial);
        setAnimationClass('fade-in-up');
      }, 500); // Match CSS transition duration
    }
  }, [testimonial, displayedTestimonial.review]);

  useEffect(() => {
    const cycleInterval = Math.floor(Math.random() * (10000 - 5000 + 1)) + 5000; // Random interval between 5 to 10 seconds

    const intervalId = setInterval(() => {
      onReviewChange(initialReviewIndex); // Request a new review from parent
    }, cycleInterval);

    return () => clearInterval(intervalId);
  }, [onReviewChange, initialReviewIndex, displayedTestimonial.review]);

  return (
    <div className="testimonial-card">
      <div className="profile-circle">
        <img src={displayedTestimonial.image} alt={displayedTestimonial.name} />
      </div>
      <h3 className={animationClass}>{displayedTestimonial.name}</h3>
      <div className="star-rating">
        {renderStars(displayedTestimonial.rating)}
      </div>
      <p className={animationClass}>"{displayedTestimonial.review}"</p>
      <img src="/images/google_g_icon.png" alt="Google Review" className="google-logo" />
    </div>
  );
};

export default TestimonialCard;
